import { Link } from "react-router-dom";
import { categories } from "@/mocks/hoobuyData";

const footerCategories = [
  { label: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { label: "Hoodies/Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { label: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { label: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { label: "Pants/Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { label: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { label: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { label: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
];

const comparativos = [
  { label: "Hoobuy vs Pandabuy", url: "/hoobuy-vs-pandabuy" },
  { label: "Hoobuy vs CNFans", url: "/hoobuy-vs-cnfans" },
  { label: "Melhor Agente 2026", url: "/melhor-agente-2026" },
  { label: "Guia Completo", url: "/hoobuy-spreadsheet-guia" },
];

const legalLinks = [
  { label: "Política de Privacidade", url: "/politica-de-privacidade" },
  { label: "Termos de Uso", url: "/termos-de-uso" },
  { label: "Sobre Nós", url: "/sobre-nos" },
  { label: "Contato", url: "mailto:contato@hoobuy.makeup" },
];

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-xl font-bold font-heading text-foreground-950 whitespace-nowrap cursor-pointer">
              Hoobuy Sheet
            </Link>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              Hoobuy Spreadsheet é o maior diretório de links verificados para compradores brasileiros. Atualizado diariamente com mais de 5.000 produtos.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-foreground-500 mb-4">
              Categorias
            </h4>
            <ul className="space-y-2">
              {footerCategories.map((cat) => (
                <li key={cat.label}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-foreground-500 mb-4">
              Comparativos
            </h4>
            <ul className="space-y-2">
              {comparativos.map((comp) => (
                <li key={comp.label}>
                  <Link
                    to={comp.url}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {comp.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-foreground-500 mb-4">
              Legal
            </h4>
            <ul className="space-y-2">
              {legalLinks.map((legal) => (
                <li key={legal.label}>
                  {legal.url.startsWith("mailto:") ? (
                    <a
                      href={legal.url}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {legal.label}
                    </a>
                  ) : (
                    <Link
                      to={legal.url}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {legal.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 hoobuy.makeup. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
              aria-label="Hoobuy Sheet"
            >
              <i className="ri-external-link-line text-sm"></i>
            </a>
            <a
              href="mailto:contato@hoobuy.makeup"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
              aria-label="Email"
            >
              <i className="ri-mail-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}